import { ISubmissionSubmitItem } from '../../../model/ser/submission/request/submission-submit-request';

// Campos de uma remessa no multipart; no lote o prefixo é "Items[i]." (notação com ponto exigida pelo
// binding de IFormFile dentro de coleções no ASP.NET Core)
function appendItem(formData: FormData, item: ISubmissionSubmitItem, prefix: string) {
    formData.append(`${prefix}Title`, item.title);
    if (item.instruction) formData.append(`${prefix}Instruction`, item.instruction);
    formData.append(`${prefix}PublishDate`, item.publishDate);
    formData.append(`${prefix}Type`, String(item.type));
    item.vehicleIds.forEach((id) => formData.append(`${prefix}VehicleIds`, String(id)));
    item.files.forEach((file) => formData.append(`${prefix}Files`, file, file.name));
}

function appendClient(formData: FormData, clientId?: number) {
    if (clientId) formData.append('ClientId', String(clientId));
}

export function buildSubmissionFormData(item: ISubmissionSubmitItem, clientId?: number): FormData {
    const formData = new FormData();
    appendClient(formData, clientId);
    appendItem(formData, item, '');
    return formData;
}

export function buildBatchFormData(items: ISubmissionSubmitItem[], clientId?: number): FormData {
    const formData = new FormData();
    appendClient(formData, clientId);
    items.forEach((item, index) => appendItem(formData, item, `Items[${index}].`));
    return formData;
}
